import React from "react";

import Button from '../Button'

import { useTranslation, Trans } from "react-i18next";

function JoinUs () {

    const { t } = useTranslation();
      
    return(
        <div className="pt-[100px] xl:pt-[160px] pb-[100px] xl:pb-[160px]">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto bg-[#353535] h-[429px] rounded-[20px] flex flex-col items-center justify-center">
                <p className="merriweather italic text-white text-[25px] xl:text-[40px] font-[700] text-center"><Trans>{t('fees.14')}</Trans></p>
                <p className="text-white text-[14px] xl:text-[16px] text-center font-[300] md:max-w-[592px] inter mt-[20px] mx-[20px]">{t('fees.15')}</p>
                <Button className={"mt-[30px] xl:mt-[40px]"}/>
            </div>
        </div>
    );
}

export default JoinUs;